import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";
import { Connection as ConnectionType } from "/app/src/models";
import { useCallback, useMemo } from "react";
import useSetting from "../setting";
import RequestForm from "/app/src/components/generic/components/requestForm";

export default function TestBody({
  connection,
}: {
  connection: ConnectionType;
}) {
  const { t } = useTranslation();

  const { settingValue, createUpdateSetting } = useSetting({
    connectionId: connection.id,
    type: "testBody",
  });

  const handleSubmit = useCallback(
    async (values: { value: string }) => {
      await createUpdateSetting({
        ...values,
        type: "testBody",
        name: "Test Body",
        connectionId: connection.id,
      });
    },
    [createUpdateSetting, connection.id],
  );

  const testBodyContent = useMemo(
    () => (
      <>
        {t("translation:test_body")}
        <IconToolTip
          content={t("translation:test_body_tip")}
          className="ml-1"
        />
      </>
    ),
    [t],
  );

  return (
    <Formik
      enableReinitialize
      initialValues={{
        value: settingValue,
      }}
      onSubmit={handleSubmit}
    >
      <RequestForm label={testBodyContent} />
    </Formik>
  );
}
